import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import "normalize-css";
import './sass/main.css';
import { history } from './helpers/history.js';

import "es6-promise/auto";
import App from './containers/App';
// import { unregister, registerServiceWorker } from './registerServiceWorker';
import { unregister } from './registerServiceWorker';

//redux
import {Provider} from 'react-redux';
import store from './configureStore.js';
import { configureFakeBackend } from './scripts/ConfigureFakeBackend.js';

// polyfills
import 'es6-shim'
import 'es7-shim'

configureFakeBackend();

ReactDOM.render((
    <Provider store={store}>
        <Router history={history}>
            <App/>
        </Router>
    </Provider>
), document.getElementById('root'));

// registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.js